import { Tag, TagColorType } from "components/DesignSystem/Tag/Tag";
import { TaskRelatedFile } from "./TaskRelatedFile";
import {
  bookkeepingStatuses,
  Form1120BookkeepingStatus,
} from "types/Models/TaskTracker";
import {
  BOOKKEEPING_COMPLETED,
  BOOKKEEPING_IN_PROGRESS,
  BOOKKEEPING_SHARED,
  BOOKKEEPING_UNPAID,
} from "../Task1120FilterOptions";

export const bookkeepingStatusLabels: Record<
  bookkeepingStatuses,
  Record<string, string>
> = {
  [BOOKKEEPING_UNPAID]: {
    color: "orange",
    text: "Unpaid",
  },
  [BOOKKEEPING_IN_PROGRESS]: {
    color: "orange",
    text: "In Progress",
  },
  [BOOKKEEPING_SHARED]: {
    color: "green",
    text: "Shared by client",
  },
  [BOOKKEEPING_COMPLETED]: {
    color: "green",
    text: "Completed",
  },
};

export const BookkeepingStatus = ({
  bookkeepingStatus,
  groupId,
}: {
  bookkeepingStatus: Form1120BookkeepingStatus | null;
  groupId: string;
}) => {
  if (!bookkeepingStatus || !bookkeepingStatus?.status) {
    return "-";
  }

  return (
    <div
      className="t-flex t-justify-between t-items-center t-pr-2"
      onClick={(e) => e.stopPropagation()}
    >
      <Tag
        icon={false}
        tagType={
          bookkeepingStatusLabels[bookkeepingStatus.status]
            ?.color as TagColorType
        }
        rounded
      >
        {bookkeepingStatusLabels[bookkeepingStatus.status]?.text}
      </Tag>
      <div className="t-flex t-gap-1">
        {bookkeepingStatus.files?.map((document) => (
          <TaskRelatedFile
            fileId={document.uuid}
            fileType={document.file_type}
            key={document.uuid}
            groupId={groupId}
          />
        ))}
      </div>
    </div>
  );
};
